// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hierarchy-tree.ant-tree > div:first-child {
  display: none;
}
`, "",{"version":3,"sources":["webpack://./client/modules/data-feeds/components/CountryHierarchyTree.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf","sourcesContent":[":global .hierarchy-tree.ant-tree > div:first-child {\n  display: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
